import useWebchatScript from "../hooks/useWebchatScript";

const WebchatManager = () => {
  useWebchatScript();
  return null;
};

export default WebchatManager;
